module.exports = __webpack_public_path__ + "static/media/medicare-card.9c8bbb79.jpeg";